import { v4 as uuid } from 'uuid'

export default (eventId, userId) => `photos/${eventId}/${userId}/${uuid()}`
